import React from "react";
import { Link } from "react-router-dom";
import NotFoundImg from "../images/page-not-found.svg";
import { INITIAL_ROUTE, SIGNIN_ROUTE } from "../constants/RoutePath";

export default function PageNotFound(props) {
  return (
    <div id="notfound">
      <div className="notfound">
        <div className="notfound-404">
          <img src={NotFoundImg} />
          <h1 className="not-found-title">404 We are sorry, Page not found!</h1>
          <p className="not-found-text">
            The page you are looking for might have been removed had its name
            changed or is temporarily unavailable.
          </p>
          <Link className="back-to-homebtn" to={SIGNIN_ROUTE}>
            Back To Homepage
          </Link>
        </div>
      </div>
    </div>
  );
}
